/*
* ProfileLib
*
* This lib provides procedures to handle common tasks surrounding the GOOD3
* profiles. Any component displaying profiles should probably add this mixin.
*/

// AXIOS for HTTPS requests
import axios from 'axios'

// The LIBRARY
export const ProfileLib = {
  data: () => ({

  }),
  methods: {
    // loadProfiles grabs the profiles from the backend and then displays it
    // in the Dashboard component.
    loadProfiles () {
      // lets display the status
      this.requestStatus = 'calling GOOD3 API ...'
      this.requestProgress = 0
      this.requestLoading = true
      this.outputAlert = false
      this.outputMessage = ''

      // calling GOOD3 to retrieve the profiles
      axios.post(this.helpMeBackendURLForPath('good3?action=getProfiles'),
        {
          version: '1.0',
          name: 'getProfiles',
          timeout: 10000
        }
      )
        .then(response => {
          this.handleGetProfilesCall(response)
        })
        .catch(error => {
          this.requestLoading = true
          this.requestProgress = 100
          this.outputMessage = 'Back-end cannot be reached, this is sad news!'
          this.outputAlert = true
          console.log(error)
        })
    },
    // handleGetProfilesCall verifies that there was no error at the HTTP layer
    // and no error at the application layer. Then it populates the profiles
    // list.
    handleGetProfilesCall (pResponse) {
      this.requestProgress = 30
      this.requestStatus = 'parsing the response ...'

      // basic sanity check
      if (!pResponse) {
        this.requestProgress = 100
        this.outputMessage = 'Back-end cannot be reached, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the HTTP layer
      if (pResponse.status !== 200) {
        this.requestProgress = 100
        this.outputMessage = 'Back-end forbids our calls, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the application layer
      if (!pResponse.data) {
        this.requestProgress = 100
        this.outputMessage = 'Back-end failed processing our request, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the application layer. if the application server tells us the
      // authentication failed we catch the specific code.
      if (pResponse.data.error) {
        switch (pResponse.data.error.code) {
          case 'GOOD3_AUTHENTICATION_FAILED':
            this.outputMessage = 'Authentication failed!'
            break
          default:
            this.outputMessage = 'Back-end failed processing our request, this is sad news!'
        }

        this.requestProgress = 100
        this.outputAlert = true

        // stopping here since there was an application error
        return
      }

      if (!pResponse.data.data) {
        this.outputMessage = 'Back-end did not send your identity back, this is sad news!'
        this.requestProgress = 100
        this.outputAlert = true
        return
      }

      // we have the profiles list ([]*good3ObjectProfile) into pResponse.data.data
      this.requestProgress = 80
      this.requestStatus = 'storing the profiles ...'
      var vProfiles = pResponse.data.data
      this.$store.commit('setProfiles', vProfiles)

      // we are done
      this.requestLoading = false
      this.requestProgress = 100
      this.requestStatus = 'done.'
    },

    // loadSelectedProfile grabs the full profile from the backend and then displays it
    // in the Profile component.
    loadSelectedProfile () {
      // lets display the status
      this.requestStatus = 'calling GOOD3 API ...'
      this.requestProgress = 0
      this.requestLoading = true
      this.outputAlert = false
      this.outputMessage = ''

      // calling GOOD3 to retrieve the profiles
      axios.post(this.helpMeBackendURLForPath('good3?action=getProfile'),
        {
          version: '1.0',
          name: 'getProfile',
          timeout: 10000,
          profile_id: this.armorySelectedProfileID
        }
      )
        .then(tResponse => {
          // update the interface
          this.handleGetProfileCall(tResponse)

          // load the heroes list
          this.loadSelectedHeroesForProfile()
        })
        .catch(tError => {
          this.requestLoading = true
          this.requestProgress = 100
          this.outputMessage = 'Back-end cannot be reached, this is sad news!'
          this.outputAlert = true
          console.log(tError)
        })
    },

    // handleGetProfilsCall verifies that there was no error at the HTTP layer
    // and no error at the application layer. Then it populates the selected
    // profile object.
    handleGetProfileCall (pResponse) {
      this.requestProgress = 30
      this.requestStatus = 'parsing the response ...'

      // basic sanity check
      if (!pResponse) {
        this.requestProgress = 100
        this.outputMessage = 'Back-end cannot be reached, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the HTTP layer
      if (pResponse.status !== 200) {
        this.requestProgress = 100
        this.outputMessage = 'Back-end forbids our calls, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the application layer
      if (!pResponse.data) {
        this.requestProgress = 100
        this.outputMessage = 'Back-end failed processing our request, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the application layer. if the application server tells us the
      // authentication failed we catch the specific code.
      if (pResponse.data.error) {
        switch (pResponse.data.error.code) {
          case 'GOOD3_AUTHENTICATION_FAILED':
            this.outputMessage = 'Authentication failed!'
            break
          default:
            this.outputMessage = 'Back-end failed processing our request, this is sad news!'
        }

        this.requestProgress = 100
        this.outputAlert = true

        // stopping here since there was an application error
        return
      }

      if (!pResponse.data.data) {
        this.outputMessage = 'Back-end did not send your identity back, this is sad news!'
        this.requestProgress = 100
        this.outputAlert = true
        return
      }

      // we have the profile (*good3ObjectProfile) into pResponse.data.data
      this.requestProgress = 80
      this.requestStatus = 'storing the selected profile ...'
      var vProfile = pResponse.data.data
      this.$store.commit('setSelectedProfile', vProfile)

      // we are done
      this.requestLoading = false
      this.requestProgress = 100
      this.requestStatus = 'done.'

      // content is available
      // this.profileInformationReady = true
    },

    // loadSelectedHeroesForProfile grabs the heroes list belonging to the profile
    // from the backend and then displays it in the Profile component.
    loadSelectedHeroesForProfile () {
      // lets display the status
      this.requestStatus = 'calling GOOD3 API ...'
      this.requestProgress = 0
      this.requestLoading = true
      this.outputAlert = false
      this.outputMessage = ''

      // calling GOOD3 to retrieve the profiles
      axios.post(this.helpMeBackendURLForPath('good3?action=getHeroesForProfile'),
        {
          version: '1.0',
          name: 'getHeroesForProfile',
          timeout: 10000,
          profile_id: this.armorySelectedProfileID
        }
      )
        .then(tResponse => {
          // update the interface
          this.handleGetHeroesForProfileCall(tResponse)

          // load the profile history
          this.loadSelectedProfileHistory()
        })
        .catch(tError => {
          this.requestLoading = true
          this.requestProgress = 100
          this.outputMessage = 'Back-end cannot be reached, this is sad news!'
          this.outputAlert = true
          console.log(tError)
        })
    },

    // handleGetHeroesForProfileCall verifies that there was no error at the HTTP layer
    // and no error at the application layer. Then it populates the selected
    // heroes object.
    handleGetHeroesForProfileCall (pResponse) {
      this.requestProgress = 30
      this.requestStatus = 'parsing the response ...'

      // basic sanity check
      if (!pResponse) {
        this.requestProgress = 100
        this.outputMessage = 'Back-end cannot be reached, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the HTTP layer
      if (pResponse.status !== 200) {
        this.requestProgress = 100
        this.outputMessage = 'Back-end forbids our calls, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the application layer
      if (!pResponse.data) {
        this.requestProgress = 100
        this.outputMessage = 'Back-end failed processing our request, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the application layer. if the application server tells us the
      // authentication failed we catch the specific code.
      if (pResponse.data.error) {
        switch (pResponse.data.error.code) {
          case 'GOOD3_AUTHENTICATION_FAILED':
            this.outputMessage = 'Authentication failed!'
            break
          default:
            this.outputMessage = 'Back-end failed processing our request, this is sad news!'
        }

        this.requestProgress = 100
        this.outputAlert = true

        // stopping here since there was an application error
        return
      }

      if (!pResponse.data.data) {
        this.outputMessage = 'Back-end did not send your identity back, this is sad news!'
        this.requestProgress = 100
        this.outputAlert = true
        return
      }

      // we have the heroes list ([]*good3ObjectHero) into pResponse.data.data
      this.requestProgress = 80
      this.requestStatus = 'storing the selected profile ...'
      var vHeroes = pResponse.data.data

      // lets sort it so the most recently seen in game is
      // shown first in the list.
      vHeroes.sort(function (a, b) { return new Date(b.last_updated) - new Date(a.last_updated) })

      // and stroring it
      this.$store.commit('setSelectedHeroesForProfile', vHeroes)

      // we are done
      this.requestLoading = false
      this.requestProgress = 100
      this.requestStatus = 'done.'

      // content is available
      this.profileInformationReady = true
    },

    // loadSelectedProfileHistory grabs the full profile history from the
    // backend and then updated the SVGs in the Profile component.
    loadSelectedProfileHistory () {
      // lets display the status
      this.graphUpdateStatus = 'calling GOOD3 API ...'
      this.graphUpdateProgress = 0
      this.graphUpdateLoading = true
      this.graphUpdateAlert = false
      this.graphUpdateMessage = ''

      // calling GOOD3 to retrieve the profiles
      axios.post(this.helpMeBackendURLForPath('good3?action=getProfileHistory'),
        {
          version: '1.0',
          name: 'getProfileHistory',
          timeout: 10000,
          profile_id: this.armorySelectedProfileID
        }
      )
        .then(tResponse => {
          // update the graphs
          this.handleGetProfileHistoryCall(tResponse)
        })
        .catch(tError => {
          this.graphUpdateLoading = true
          this.graphUpdateProgress = 100
          this.graphUpdateMessage = 'Back-end cannot be reached, this is sad news!'
          this.graphUpdateAlert = true
          console.log(tError)
        })
    },

    // handleGetProfileHistoryCall verifies that there was no error at the HTTP
    // layer and no error at the application layer. Then it updates the SVGs
    // displaying the profile history.
    handleGetProfileHistoryCall (pResponse) {
      this.graphUpdateProgress = 30
      this.graphUpdateStatus = 'parsing the response ...'

      // basic sanity check
      if (!pResponse) {
        this.graphUpdateProgress = 100
        this.graphUpdateMessage = 'Back-end did not send a response, this is sad news!'
        this.graphUpdateAlert = true
        return
      }

      // checking the HTTP layer
      if (pResponse.status !== 200) {
        this.graphUpdateProgress = 100
        this.graphUpdateMessage = 'Back-end forbids our calls, this is sad news!'
        this.graphUpdateAlert = true
        return
      }

      // checking the application layer
      if (!pResponse.data) {
        this.graphUpdateProgress = 100
        this.graphUpdateMessage = 'Back-end failed processing our request, this is sad news!'
        this.graphUpdateAlert = true
        return
      }

      // checking the application layer. if the application server tells us the
      // authentication failed we catch the specific code.
      if (pResponse.data.error) {
        switch (pResponse.data.error.code) {
          case 'GOOD3_AUTHENTICATION_FAILED':
            this.graphUpdateMessage = 'Authentication failed!'
            break
          default:
            this.graphUpdateMessage = 'Back-end failed processing our request, this is sad news!'
        }

        this.graphUpdateProgress = 100
        this.graphUpdateAlert = true

        // stopping here since there was an application error
        return
      }

      if (!pResponse.data.data) {
        this.graphUpdateMessage = 'Back-end did not send your identity back, this is sad news!'
        this.graphUpdateProgress = 100
        this.graphUpdateAlert = true
        return
      }

      // we have the profile history ([]*good3ObjectProfileHistory) into pResponse.data.data
      this.graphUpdateProgress = 50
      this.graphUpdateStatus = 'updating the graphs ...'
      var vProfileHistory = pResponse.data.data
      this.$store.commit('setSelectedProfileHistory', vProfileHistory)

      // we are done
      this.graphUpdateProgress = 100
      this.graphUpdateStatus = 'done.'
      this.graphUpdateLoading = false

      // content is available
      this.profileHistoryReady = true
    },

    // profileNameFromBattleTag returns only the name of the profile from the
    // battle tag. This basically trim the ID from the battle tag. This proc
    // expects the Battle Tag to use the # char and not the dash char.
    profileNameFromBattleTag (pBattleTag) {
      return pBattleTag.split('#')[0]
    },

    // howLongAgo translate a timestamp into a string
    howLongAgo (pTimeStamp) {
      let vTime = Date.parse(pTimeStamp)
      let vElapsedTime = Date.now() - vTime

      // less than a second seconds
      vElapsedTime /= 1000.0
      if (vElapsedTime < 1) {
        return 'a second ago'
      }

      // a few seconds ago
      if (vElapsedTime < 20) {
        return 'a few seconds ago'
      }

      // about a minute
      vElapsedTime /= 60.0
      if (vElapsedTime < 1.6) {
        return 'a minute ago'
      }

      // x minutes ago
      if (vElapsedTime < 60) {
        return Math.round(vElapsedTime) + ' minutes ago'
      }

      // about an hour ago
      vElapsedTime /= 60.0
      if (vElapsedTime < 1.6) {
        return 'an hour ago'
      }

      // x hours ago
      if (vElapsedTime < 24) {
        return Math.round(vElapsedTime) + ' hours ago'
      }

      // about a day ago
      vElapsedTime /= 24.0
      if (vElapsedTime < 1.6) {
        return 'a day ago'
      }

      // x days ago
      if (vElapsedTime < 30) {
        return Math.round(vElapsedTime) + ' days ago'
      }

      // about a month ago
      vElapsedTime /= 30.0
      if (vElapsedTime < 1.6) {
        return 'a month ago'
      }

      // x months ago
      if (vElapsedTime < 12) {
        return Math.round(vElapsedTime) + ' months ago'
      }

      // about a year ago
      vElapsedTime *= (30.0 / 356.0)
      if (vElapsedTime < 1.6) {
        return 'a year ago'
      }

      // x years ago
      return Math.round(vElapsedTime) + ' years ago'
    },

    // humanDate translate a timestamp into a nice string
    // using words like today or yesterday instead of standard
    // ISO date representation.
    humanDate (pTimeStamp) {
      let vTime = new Date(pTimeStamp)
      let vElapsedTime = Date.now() - vTime
      let vNowTime = new Date()
      let vYesterday = new Date()
      vYesterday.setDate(vYesterday.getDate() - 1)

      // days since last update
      vElapsedTime /= (1000.0 * 60 * 60 * 24)

      // today or yesterday
      if (vElapsedTime < 2) {
        var tOptions = {
          hour: 'numeric',
          hour12: true,
          minute: '2-digit'
        }
        var tTime = vTime.toLocaleTimeString('en-GB', tOptions)
        if (vTime.getDate() === vNowTime.getDate()) {
          return 'today at ' + tTime
        } else if (vTime.getDate() === vYesterday.getDate()) {
          return 'yesterday at ' + tTime
        }
      }

      // same year we don't display the year
      if (vTime.getFullYear() === vNowTime.getFullYear()) {
        tOptions = {
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          hour12: true,
          minute: '2-digit'
        }
        return vTime.toLocaleDateString('en-GB', tOptions)
      }

      tOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        hour12: true,
        minute: '2-digit'
      }
      return vTime.toLocaleDateString('en-GB', tOptions)
    }
  }
}
